export function isMac() {
  return window.navigator.platform.toUpperCase().indexOf("MAC") >= 0;
}

export function isAndroid() {
  return window.navigator.userAgent.indexOf("Android") >= 0;
}
